import { render, staticRenderFns } from "./RedBookList.vue?vue&type=template&id=77cdedbc&scoped=true&"
import script from "./RedBookList.vue?vue&type=script&lang=js&"
export * from "./RedBookList.vue?vue&type=script&lang=js&"
import style0 from "./RedBookList.vue?vue&type=style&index=0&id=77cdedbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cdedbc",
  null
  
)

export default component.exports